import * as React from 'react';

function NotEnoughData({data} :any) {
  return (
    <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <p className="card-description">Not enough data to analyze {data.company_name}</p>
        </div>
      </div>
    </div>
  );
}

export default NotEnoughData;
